/* src/views/ResourcesView.js */
import { ref, reactive, computed, onMounted } from 'vue'
import { Layers, Box, Plus, Edit, Trash2, X, AlertCircle, CheckCircle2, Ban } from 'lucide-vue-next'
import { ResourcesService } from '@/services/ResourcesService'
import Swal from 'sweetalert2'

export default {
  name: 'ResourcesView',
  components: { Layers, Box, Plus, Edit, Trash2, X, AlertCircle, CheckCircle2, Ban },
  setup() {

    const activeTab = ref('categories')
    const categories = ref([])
    const resources = ref([])
    const deleteTarget = ref({ type: null, id: null })
    const showDeleteModal = ref(false)

    const isCatDrawerOpen = ref(false)
    const catFormError = ref(null)
    const catForm = reactive({ id: null, name: '' })
    const isResDrawerOpen = ref(false)
    const resFormError = ref(null)
    const resForm = reactive({ id: null, name: '', categoryId: null })
    const resCategoryFilter = ref('all')
    const closeCatDrawer = () => { isCatDrawerOpen.value = false }
    const closeResDrawer = () => { isResDrawerOpen.value = false }

    const openCatCreate = () => {
      catForm.id = null
      catForm.name = ''
      isCatDrawerOpen.value = true
    }
    
    const openCatEdit = (cat) => {
      catForm.id = cat.id
      catForm.name = cat.name
      isCatDrawerOpen.value = true
    }

    const getCategoryName = (id) => {
    
      const cat = categories.value.find(c => c.id === id)
      return cat ? cat.name : 'N/A'
    }
    
    const openResCreate = () => {
    
      resForm.id = null
      resForm.name = ''
      resForm.categoryId = null
      isResDrawerOpen.value = true
    }
    
    const openResEdit = (res) => {
    
      resForm.id = res.id
      resForm.name = res.name
      resForm.categoryId = res.categoryId
      isResDrawerOpen.value = true
    }

    const saveCategory = async () => {

      try {

        if (catForm.id) {

          await ResourcesService.updateCategory(catForm.id, catForm)
        } 
        else {
        
          await ResourcesService.createCategory(catForm)
        }
        
        await fetchCategories() // Ricarica la lista
        closeCatDrawer()
      } 
      catch (error) {
      
        catFormError.value = "Errore durante il salvataggio categoria"
      }
    }

    const filteredResources = computed(() => {

      if (resCategoryFilter.value === 'all') {

        return resources.value
      }

      return resources.value.filter(r => r.categoryId === resCategoryFilter.value)
    })

    const saveResource = async () => {
    
      try {
    
        if (resForm.id) {
    
          await ResourcesService.updateResource(resForm.id, resForm)
        } 
        else {
        
          await ResourcesService.createResource(resForm)
        }
        
        await fetchResources()
        closeResDrawer()
      } 
      catch (error) {
      
        resFormError.value = "Errore durante il salvataggio risorsa"
      }
    }

    const fetchCategories = async () => {
      
      try {
      
        categories.value = await ResourcesService.getAllCategories()
      } 
      catch (error) {
      
        console.error("Errore fetch categorie:", error)
      }
    }

    const fetchResources = async () => {
      try {
     
        resources.value = await ResourcesService.getAllResources()
      } 
      catch (error) {
      
        console.error("Errore fetch risorse:", error)
      }
    }

    onMounted(() => {
      
      fetchCategories()
      fetchResources()
    })

    const confirmDelete = (type, id) => {
      
      deleteTarget.value = { type, id }
      showDeleteModal.value = true
    }

    const executeDelete = async () => {

      const { type, id } = deleteTarget.value

      try {

        if (type === 'category') {

          await ResourcesService.deleteCategory(id)
        }

        else {

          await ResourcesService.deleteResource(id)
        }

        await fetchCategories()
        await fetchResources()
      } 
      catch (error) {
      
        console.error("Errore eliminazione:", error)
      } 
      finally {
      
        showDeleteModal.value = false
      }
    }

    const deleteCategory = (id) => {

      const linkedResourcesCount = resources.value.filter(r => r.categoryId === id).length

      if (linkedResourcesCount > 0) {

        console.warn(`Impossibile eliminare: ${linkedResourcesCount} risorse collegate.`)
        return
      }

      confirmDelete('category', id)
    }

    const deleteResource = (id) => {

      confirmDelete('resource', id)
    }

    return {
      activeTab, categories, resources,
      isCatDrawerOpen, catFormError, catForm, openCatCreate, openCatEdit, closeCatDrawer, saveCategory, deleteCategory,
      isResDrawerOpen, resFormError, resForm, resCategoryFilter, filteredResources, getCategoryName, openResCreate, openResEdit, closeResDrawer, saveResource, deleteResource,
      showDeleteModal, confirmDelete, executeDelete
    }
  }
}